import { bizRequest } from "../../bizClient"; // Import the API helper

const getLocations = async (customerId, userId, subscription) => {
    const url = userId ? `/api/locations/getLocationsByCustomerId/${customerId}/${subscription}/${userId}` : `/api/locations/getLocationsByCustomerId/${customerId}`
    return await bizRequest(url)
    .then(data => {
        return data
    })
    .catch((error) => error);
}

const saveLocation = async (location, userRoles) => {

    const flattendUserRoles = Object.values(userRoles)
        .flatMap(roleGroup => 
        ['editor', 'viewer'].flatMap(role => 
            Array.isArray(roleGroup[role]) ? roleGroup[role] : []
        )
    );

    //If location already exists, update instead of create
    const url = `/api/locations/saveLocation`;
    
    return await bizRequest(url, 'POST', { 'Content-Type': 'application/json' }, { location, userLocations: flattendUserRoles })
    .then(resp => {
        return resp
    })
    .catch((error) => {
        console.error(error);
    });
}

const formatLocationAddress = (location) => {
    if (!location) return "";

    const { address1, city, state, zip, country } = location;

    //Build the parts while ensuring correct formatting
    const addressParts = [];

    if (address1) addressParts.push(address1);
    if (city) addressParts.push(city);

    //Correctly format "State Zip"
    if (state && zip) {
        addressParts.push(`${state} ${zip}`);
    } else if (state) {
        addressParts.push(state);
    } else if (zip) {
        addressParts.push(zip);
    }

    if (country) addressParts.push(country);

    // Join with ", " for correct address formatting
    return addressParts.join(", ");
}

const getUserRolesForLocation = async (locationId) => {
    return await bizRequest(`/api/userLocations/getUsersGroupedBySubscriptions/${locationId}`)
    .then(data => {
        return data
    })
    .catch((error) => error);
}

const formatAddress = (location) => {
    let address = '';
    if (location?.address1) {
        address += location?.address1
    }

    if (location?.city) {
        address += `, ${location?.city}`
    }

    if (location?.state && location?.zip) {
        address += `, ${location?.state} ${location?.zip}`
    }
    else if (location?.state) {
        address += `, ${location?.state}`
    }
    else if (location?.zip) {
        address += `, ${location?.zip}`
    }

    return address
}

export {
    getLocations,
    saveLocation,
    formatLocationAddress,
    getUserRolesForLocation,
    formatAddress,
}
